import React from 'react';
import { Lock } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useSidebar } from '../../contexts/SidebarContext';

/**
 * PremiumFeatureBlock — bloco ÚNICO de "Recurso Premium" para TODAS as páginas
 * bloqueáveis (Vídeos Virais, Nichos Virais, Lista de Nichos, Insights de Canal).
 *
 * Padronização TOTAL: o componente é dono do `<main>` centralizado (lê useSidebar
 * p/ a margem do menu), então o card aparece EXATAMENTE na mesma posição em todas —
 * centralizado horizontal e verticalmente na área de conteúdo. Cada página só
 * renderiza <Sidebar/> + <Header/> + <PremiumFeatureBlock/> (chrome preservado).
 *
 * Texto via i18n premium.* (pt/en/es). Botão = gradiente oficial SÓLIDO, sem blur.
 */
export default function PremiumFeatureBlock() {
  const { t } = useTranslation();
  const { sidebarWidth, isMobile } = useSidebar();
  return (
    <main
      className="dp-main-content"
      style={{
        marginLeft: isMobile ? 0 : `${sidebarWidth}px`,
        marginTop: '60px',
        flex: 1,
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        boxSizing: 'border-box',
        transition: 'margin-left 0.3s ease',
        fontFamily: 'var(--dp-font)',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 8, scale: 0.985 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
        style={{
          maxWidth: 440,
          width: '100%',
          padding: '40px 36px',
          borderRadius: 'var(--dp-radius-lg, 16px)',
          border: '1px solid var(--dp-border-subtle)',
          background: 'var(--dp-bg-card)',
          textAlign: 'center',
          fontFamily: 'var(--dp-font)',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.25)',
        }}
      >
        {/* Ícone em círculo com o azul da marca — lucide Lock (nunca emoji) */}
        <div
          style={{
            width: 64,
            height: 64,
            margin: '0 auto 20px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(13, 174, 255, 0.10)',
            border: '1px solid rgba(13, 174, 255, 0.20)',
          }}
        >
          <Lock size={28} style={{ color: 'var(--dp-blue-500, #0DAEFF)' }} />
        </div>

        <h2
          style={{
            margin: '0 0 10px',
            fontSize: 22,
            fontWeight: 700,
            color: 'var(--dp-text-primary)',
          }}
        >
          {t('premium.title')}
        </h2>

        <p
          style={{
            margin: '0 0 24px',
            fontSize: 14,
            lineHeight: 1.6,
            color: 'var(--dp-text-secondary)',
          }}
        >
          {t('premium.message')}
        </p>

        {/* [tela de compra removida] Sem CTA de compra: o cadeado só informa que o recurso é
            premium. Nada de botão levando à tela de planos (que foi removida). */}
      </motion.div>
    </main>
  );
}
